import _ from 'lodash';
import MetadataDrivenCommon from './common/MetadataDrivenCommon';

class MetadataDrivenField extends MetadataDrivenCommon {
    constructor(viewModel, pageDefinition, contentPath) {

        // check if it can be removed
        contentPath = contentPath.includes('.') ? contentPath : `fields.${contentPath}`;
        super(viewModel, pageDefinition, contentPath, 'field');

        this._viewModelNodeName = contentPath.split('.').pop();

        if (Array.isArray(this.dataProps.detailField)) {
            this.parseContent(this.dataProps.detailField);
        }
    }

    get fieldViewModel() {
        if (this.presentationModel.path) {
            return this._getViewModelFromPath(this.presentationModel.path);
        }
        return this.viewModel[this._viewModelNodeName];
    }

    get component() {
        return this.presentationModel.component;
    }

    get label() {
        return this.presentationModel.label;
    }

    get tooltip() {
        return this.presentationModel.tooltip;
    }

    get layout() {
        return this.presentationModel.layout;
    }

    get isVisible() {
        const isRequired = this.fieldViewModel.aspects.required;
        const isVisible = super.isVisible;
        const value = this.fieldViewModel.value;
        if (isRequired && value === undefined && !isVisible) {
            console.warn('Attempt to hide an required field without default value');
            return true;
        }
        return isVisible;
    }

    /**
     * Returns the view model based on path provided in presentationModel
     * @param {string} viewModelPath - input.path defined in presentationModel
     * @returns {VMNode}
     * @private
     */
    _getViewModelFromPath(viewModelPath) {
        return _.get(this.viewModel, viewModelPath);
    }

}
export default MetadataDrivenField;